// extracted by mini-css-extract-plugin
export default {"resetButton":"T9ncGuit5XEty3PJKFkZ"};